( function ( $ ) {
	const REDUCED_MOTION = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	const OVERLAY_MODE = window.matchMedia( '(min-width: 768px)' );
	// single column: the second image needs the scroll position as a trigger, because there
	// is no room for a hover hint and touch devices have no hover at all
	const CENTER_REVEAL_MODE = window.matchMedia( '(max-width: 767.98px)' );

	class PeopleFilter {
		constructor( block ) {
			this.block = $( block );
			this.searchWrapper = this.block.find( '.indy-block-people-search' );
			this.searchToggle = this.block.find( '[data-people-search-toggle]' );
			this.searchInput = this.block.find( '[data-people-search]' );
			this.areaButtons = this.block.find( '[data-people-area-button]' );
			this.items = this.block.find( '[data-people-item]' );
			this.emptyMessage = this.block.find( '[data-people-empty]' );
			this.filterRun = 0;

			this.searchToggle.on( 'click', this.toggleSearch.bind( this ) );
			this.block.find( '[data-people-search-close]' ).on( 'click', () => {
				this.closeSearch();
				( OVERLAY_MODE.matches ? this.searchToggle : this.searchInput ).trigger( 'focus' );
			} );
			this.searchInput.on( 'input', this.filter.bind( this ) );
			this.searchInput.on( 'keydown', ( event ) => {
				if ( event.key === 'Escape' ) {
					this.closeSearch();
					this.searchToggle.trigger( 'focus' );
				}

				if ( event.key === 'Enter' ) {
					event.preventDefault();
					this.searchInput.trigger( 'blur' );
				}
			} );
			this.searchInput.on( 'blur', this.collapseEmptySearch.bind( this ) );
			this.areaButtons.on( 'click', this.setArea.bind( this ) );
			OVERLAY_MODE.addEventListener( 'change', this.syncSearchMode.bind( this ) );
			this.syncSearchMode();

			// only touch devices toggle by tap; with a mouse the image already shows on hover
			if ( window.matchMedia( '(hover: none)' ).matches ) {
				this.block.find( '[data-people-hover-toggle]' ).on( 'click', this.toggleHoverImage.bind( this ) );
			}

			CENTER_REVEAL_MODE.addEventListener( 'change', this.syncCenterReveal.bind( this ) );
			this.syncCenterReveal();
		}

		// on a phone there is neither hover nor a visible hint to tap, so the second image
		// is revealed while the card passes the middle of the screen
		syncCenterReveal() {
			if ( ! CENTER_REVEAL_MODE.matches ) {
				if ( this.centerObserver ) {
					this.centerObserver.disconnect();
					this.centerObserver = null;
					this.resetHoverImages();
				}
				return;
			}

			if ( this.centerObserver || typeof IntersectionObserver === 'undefined' ) {
				return;
			}

			// collapsing the root to a zero height line in the middle makes an entry
			// intersect exactly while it covers that line
			this.centerObserver = new IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						this.setHoverImage( entry.target, entry.isIntersecting );
					} );
				},
				{ rootMargin: '-50% 0px -50% 0px' }
			);

			this.block.find( '.tease-img.has-hover-image' ).each( ( index, image ) => {
				this.centerObserver.observe( image );
			} );
		}

		setHoverImage( image, show ) {
			$( image )
				.toggleClass( 'is-hover-visible', show )
				.find( '[data-people-hover-toggle]' )
				.attr( 'aria-pressed', show ? 'true' : 'false' );
		}

		syncSearchMode() {
			if ( OVERLAY_MODE.matches ) {
				this.searchToggle.attr( 'aria-expanded', this.searchWrapper.hasClass( 'is-open' ) ? 'true' : 'false' );
			} else {
				this.searchToggle.removeAttr( 'aria-expanded' );
			}
		}

		toggleSearch() {
			if ( ! OVERLAY_MODE.matches ) {
				this.searchInput.trigger( 'focus' );
				return;
			}

			if ( this.searchWrapper.hasClass( 'is-open' ) ) {
				this.closeSearch();
				return;
			}

			this.searchWrapper.addClass( 'is-open' );
			this.searchToggle.attr( 'aria-expanded', 'true' );
			this.searchInput.trigger( 'focus' );
		}

		closeSearch() {
			this.searchWrapper.removeClass( 'is-open' );

			if ( OVERLAY_MODE.matches ) {
				this.searchToggle.attr( 'aria-expanded', 'false' );
			}

			if ( this.searchInput.val() ) {
				this.searchInput.val( '' );
				this.filter();
			}
		}

		collapseEmptySearch( event ) {
			if ( OVERLAY_MODE.matches && this.searchInput.val().trim() === '' && ! $.contains( this.searchWrapper[ 0 ], event.relatedTarget ) ) {
				this.closeSearch();
			}
		}

		setArea( event ) {
			const button = $( event.currentTarget );

			this.areaButtons
				.removeClass( 'active' )
				.attr( 'aria-pressed', 'false' );

			button
				.addClass( 'active' )
				.attr( 'aria-pressed', 'true' );

			this.filter();
		}

		filter() {
			const activeArea = this.areaButtons.filter( '.active' ).data( 'area' ) || 'all';
			const searchValue = this.searchInput.val().trim().toLowerCase();

			this.searchWrapper.toggleClass( 'has-value', searchValue !== '' );
			const run = ++this.filterRun;
			const matches = new Map();

			this.items.each( ( index, item ) => {
				const matchesArea = activeArea === 'all' || String( item.dataset.areas ).split( ' ' ).includes( activeArea );
				const matchesSearch = searchValue === '' || String( item.dataset.search ).includes( searchValue );
				matches.set( item, matchesArea && matchesSearch );
			} );

			// fade out items that no longer match, then reflow and animate the rest
			const exits = REDUCED_MOTION.matches ? [] : [ ...matches ]
				.filter( ( [ item, matched ] ) => ! matched && ! item.hidden )
				.map( ( [ item ] ) => item.animate(
					[ { opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.9)' } ],
					{ duration: 200, easing: 'ease-in', fill: 'forwards' }
				) );

			Promise.allSettled( exits.map( ( animation ) => animation.finished ) ).then( () => {
				// a newer filter run took over; release the faded items to it
				if ( run !== this.filterRun ) {
					exits.forEach( ( animation ) => animation.cancel() );
					return;
				}

				const previousPositions = new Map();
				this.items.each( ( index, item ) => {
					if ( ! item.hidden ) {
						previousPositions.set( item, item.getBoundingClientRect() );
					}
				} );

				matches.forEach( ( matched, item ) => {
					item.hidden = ! matched;
				} );
				exits.forEach( ( animation ) => animation.cancel() );

				this.emptyMessage.prop( 'hidden', [ ...matches.values() ].some( Boolean ) );
				this.animateItems( previousPositions );
			} );
		}

		// FLIP: items that stay glide to their new position, new ones fade in from below
		animateItems( previousPositions ) {
			if ( REDUCED_MOTION.matches ) {
				return;
			}

			this.items.each( ( index, item ) => {
				if ( item.hidden ) {
					return;
				}

				const previous = previousPositions.get( item );

				if ( ! previous ) {
					item.animate(
						[ { opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'none' } ],
						{ duration: 300, easing: 'ease-in-out' }
					);
					return;
				}

				const next = item.getBoundingClientRect();
				const deltaX = previous.left - next.left;
				const deltaY = previous.top - next.top;

				if ( deltaX || deltaY ) {
					item.animate(
						[ { transform: `translate(${ deltaX }px, ${ deltaY }px)` }, { transform: 'none' } ],
						{ duration: 300, easing: 'ease-in-out' }
					);
				}
			} );
		}

		toggleHoverImage( event ) {
			const toggle = $( event.currentTarget );
			const image = toggle.closest( '.tease-img' );
			const show = ! image.hasClass( 'is-hover-visible' );

			clearTimeout( this.hoverRevert );
			this.resetHoverImages();

			if ( show ) {
				image.addClass( 'is-hover-visible' );
				toggle.attr( 'aria-pressed', 'true' );

				// while the scroll position drives the reveal, letting it time out would
				// hide a card that is still in the middle of the screen
				if ( ! this.centerObserver ) {
					this.hoverRevert = setTimeout( () => this.resetHoverImages(), 3000 );
				}
			}
		}

		resetHoverImages() {
			this.block.find( '.tease-img.is-hover-visible' )
				.removeClass( 'is-hover-visible' )
				.find( '[data-people-hover-toggle]' )
				.attr( 'aria-pressed', 'false' );
		}
	}

	$( '.indy-block-people[data-people-filter]' ).each( ( index, block ) => {
		new PeopleFilter( block );
	} );
} )( jQuery );
